const ScrollOffset = {
    Enter: [
        [0, 1],
        [1, 1],
    ],
    Exit: [
        [0, 0],
        [1, 0],
    ],
    Any: [
        [1, 0],
        [0, 1],
    ],
    All: [
        [0, 0],
        [1, 1],
    ],
};

export { ScrollOffset };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@motionone/dom/dist/gestures/scroll/offsets/presets.es.js
// module id = OR40
// module chunks = 0